import urls from "../common/urls";
import { http } from "../common/post";

const DevSource = {
  visitFromDiagnosis: diagnosis => http(urls.visitFromDiagnosis + diagnosis, "GET"),
};

export default DevSource


// WEBPACK FOOTER //
// ./assets/dev/Source.js